var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimplex(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notification Ad-Hoc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification-Ad-Hoc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2642741,7.375 L17.4079126,7.375 C16.9230099,7.375 16.493529,7.6887069 16.3462651,8.15073849 L12.4284926,20.3930654 L12.397073,20.5129645 C12.2582215,21.1917721 12.7765855,21.8476193 13.489918,21.8476193 L16.863,21.847 L13.8970406,31.1692354 C13.5227658,32.3471872 15.0575574,33.1689156 15.8297757,32.2036191 L27.583645,17.5117996 L27.6509608,17.4188893 C28.1237291,16.6941141 27.6089392,15.7009688 26.7130647,15.7009688 L22.5,15.7 L25.2954306,8.91420444 C25.5971609,8.18014269 25.0575593,7.375 24.2642741,7.375 Z M17.507,8.625 L24.062,8.625 L20.6341769,16.9509688 L26.431,16.95 L15.31,30.851 L18.5725962,20.5976566 L13.675,20.597 L17.507,8.625 Z",
    id: "Path",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplex);
export default __webpack_public_path__ + "static/media/simplex.b3dd71078a75d43da167a82817479051.svg";
export { ForwardRef as ReactComponent };